/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1253
 */

var r = require(/* 634 */"./634").match(/firefox\/(\d+)/i)
module.exports = !!r && +r[1]
